import { ValorDominio } from './dominio.model';

/** Comunas vacías = toda la región. Mismo formato que la API (coberturaZonas). */
export interface ZonaCobertura {
  region: string;
  comunas: string[];
}

export interface RegionCatalogo {
  nombre: string;
  comunas: string[];
}

/** Topes de la API (CoberturaReglas). */
export const MAX_COMUNAS = 400;

const igual = (a: string, b: string) => a.localeCompare(b, 'es', { sensitivity: 'accent' }) === 0;

/** Regiones del dominio "regiones" con sus comunas del dominio "comunas" (padreId = código de la región). */
export function catalogoCobertura(regiones?: ValorDominio[] | null, comunas?: ValorDominio[] | null): RegionCatalogo[] {
  const porPadre = new Map<string, string[]>();
  for (const c of comunas ?? []) if (c?.valor?.trim()) porPadre.set(c.padreId, [...(porPadre.get(c.padreId) ?? []), c.valor.trim()]);
  return (regiones ?? []).filter(r => r?.valor?.trim()).map(r => ({
    nombre: r.valor.trim(),
    comunas: [...new Set(porPadre.get(r.codigo) ?? [])].sort((a, b) => a.localeCompare(b, 'es')),
  }));
}

/** Igual que la API: cobertura (regiones) manda; una región sin zona es la región completa. */
export function zonasDe(cobertura?: string[] | null, zonas?: ZonaCobertura[] | null): ZonaCobertura[] {
  return [...new Set((cobertura ?? []).filter(r => r?.trim()))].map(r => {
    const z = zonas?.find(x => igual(x.region, r));
    return { region: r, comunas: [...(z?.comunas ?? [])] };
  });
}

/** Marca la región completa o la quita. */
export function alternarRegion(zonas: ZonaCobertura[], region: string): ZonaCobertura[] {
  return zonas.some(z => z.region === region) ? zonas.filter(z => z.region !== region) : [...zonas, { region, comunas: [] }];
}

/** En una región completa todas las comunas se ven marcadas: desmarcar una deja las demás. Todas = completa; ninguna = sin la región. */
export function alternarComuna(zonas: ZonaCobertura[], region: string, comuna: string, todas: string[]): ZonaCobertura[] {
  const zona = zonas.find(z => z.region === region);
  const actuales = !zona ? [] : zona.comunas.length ? zona.comunas : todas;
  const nuevas = actuales.includes(comuna) ? actuales.filter(c => c !== comuna) : [...actuales, comuna];
  const resto = zonas.filter(z => z.region !== region);
  if (!nuevas.length) return resto;
  const comunas = nuevas.length === todas.length ? [] : todas.filter(c => nuevas.includes(c));
  return zona ? zonas.map(z => (z.region === region ? { region, comunas } : z)) : [...resto, { region, comunas }];
}

export function cubreComuna(zonas: ZonaCobertura[], region: string, comuna: string): boolean {
  const z = zonas.find(x => x.region === region);
  return !!z && (!z.comunas.length || z.comunas.includes(comuna));
}

/** "Aysén" (completa) o "Metropolitana: Maipú, Ñuñoa"; con muchas comunas, solo cuántas. */
export function etiquetaZona(z: ZonaCobertura): string {
  if (!z.comunas.length) return z.region;
  return z.comunas.length <= 3 ? `${z.region}: ${z.comunas.join(', ')}` : `${z.region}: ${z.comunas.length} comunas`;
}

export const totalComunas = (zonas: ZonaCobertura[]) => zonas.reduce((n, z) => n + z.comunas.length, 0);
